let noCheckedHistory = new Set(['rewards', 'stacks'])
export default noCheckedHistory